import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useContext, useMemo, useState } from 'react';
import { RetentionModalCTX } from '@widgets/RetentionModal/types/config';
import useTimeout from 'beautiful-react-hooks/useTimeout';
import RetentionForm from '@widgets/RetentionModal/components/RetentionForm';
import SuccessMessage from '@widgets/RetentionModal/components/SuccessMessage';
import Styles from '@widgets/shared/styles/modal';
import { useCallback } from 'preact/compat';
import { Inner } from '@widgets/RetentionModal/components/Modal/styled';
function Modal() {
    const { delayInSeconds, loggedIn } = useContext(RetentionModalCTX);
    const [modalVisible, setModalVisible] = useState(false);
    const [formCompleted, setFormCompleted] = useState(false);
    const [successTitle, setSuccessTitle] = useState('');
    const [successCopy, setSuccessCopy] = useState('');
    const shownModal = useMemo(() => !loggedIn && modalVisible, [loggedIn, modalVisible]);
    useTimeout(() => {
        setModalVisible(true);
    }, delayInSeconds * 1000);
    const handleModalClose = useCallback(() => {
        setModalVisible(false);
        setFormCompleted(false);
    }, []);
    if (!shownModal) {
        return null;
    }
    return (_jsx(Styles.Backdrop, { children: _jsxs(Inner, { children: [_jsx(Styles.Close, { className: "close", type: "button", onClick: handleModalClose, title: "Close Modal", children: _jsx("svg", { children: _jsx("use", { xlinkHref: "#icon--tooltip-close" }) }) }), !formCompleted && (_jsx(RetentionForm, { onComplete: (title, copy) => {
                        setSuccessTitle(title);
                        setSuccessCopy(copy);
                        setFormCompleted(true);
                    } })), formCompleted && (_jsx(SuccessMessage, { title: successTitle, copy: successCopy, onClose: handleModalClose }))] }) }));
}
export default Modal;
